import { call, put, takeLatest , select } from 'redux-saga/effects';
import ApiRouts from '../../api/routes';
import {GET} from "../../api";
import {FETCH_COLLECTION_MODAL_DATA_LIST, FETCH_PRODUCT_MODAL_DATA_LIST, SET_COLLECTION_MODAL_DATA_LIST, SET_PRODUCT_LIST, SET_PRODUCT_MODAL_DATA_LIST} from "../actions";




const getSelectedProductId = (state) => state.selectProductId.selectProductId;





export function* FetchCollectionModalDataSaga() {

    const selectedId = yield select(getSelectedProductId);

    try {

        const response = yield call(GET, `${ApiRouts.API_COLLECTION_MODAL_DATA}/${selectedId}` , {});

        if (response) {

            yield put({
                type:SET_COLLECTION_MODAL_DATA_LIST,
                payload:response.data.data
            });
        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* collectionModalDataSaga() {
    yield takeLatest(FETCH_COLLECTION_MODAL_DATA_LIST, FetchCollectionModalDataSaga);
    // yield takeLatest(SET_LATEST_VERSION, setLatestVersion);
}

export default collectionModalDataSaga;
